import { render, staticRenderFns } from "./CustomerGatewaysList.vue?vue&type=template&id=958936ba&"
import script from "./CustomerGatewaysList.vue?vue&type=script&lang=js&"
export * from "./CustomerGatewaysList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGatewaysList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports